export const INTERVIEW_TYPES = {
    PHONE:   'Phone',
    VIDEO:   'Video',
    VIDEOQA: 'Video Q&A',
    TECHTEST:  'Assessment',
    FACE2FACE: 'In-Person',
    primaryColor: '#dd564d',
 }

export const INTERVIEW_TYPE_HEADERS = {
  PHONE: {
    header: 'Setup Phone Interview',
    subheader: 'Tell us where, who and how long. We’ll sort the rest.'
  },
  VIDEO: {
    header: 'Set Up Video Interview',
    subheader: 'Tell us where, who and how long. We’ll sort the rest. Need to add an extra interview? Click the button below.'
  },
  VIDEOQA: {
    header: 'Setup Video Q & A',
    subheader: 'Select a language, add an introduction video, setup questions among other things to send a Video Q&A to your candidate'
  },
  TECHTEST: {
    header: 'Setup Assessment',
    subheader: 'Pick a technical test from the dropdown list or add your own. We’ll share your candidate’s score as soon as it’s done.'
  },
  FACE2FACE: {
    header: 'Set Up In-Person Interview',
    subheader: 'No more email tennis. If you tell us the time, place and interviewers, we’ll find a slot that works for everyone.'
  },
  DEFAULT: {
    header: 'Setup Interview',
    subheader: 'Tell us where, who and how long. We’ll sort the rest.'
  }
}